import * as ng from 'angular';
import { IsEmpty } from './is-empty.filter';
import { FormatFilename } from './format-filename.filter';
import { PropsFilterObjects } from './props-filter-objects.filter';
import { PropsFilter } from './props-filter.filter';
import { OrderArchidrive } from './order-archidrive.filter';

export const FiltersModule: string = ng
    .module('archismall.filters', [])
    .filter('isEmpty', IsEmpty)
    .filter('formatFilename', FormatFilename)
    .filter('propsFilterObjects', PropsFilterObjects)
    .filter('propsFilter', PropsFilter)
    .filter('orderArchidrive', OrderArchidrive)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/filters/filters.module.ts